import { getAccountScopeUserSettings } from 'owa-session-store';
import type { MailboxInfo } from 'owa-client-types';

// Gets if Focused Inbox feature is enabled for the user
export function isFocusedInboxEnabled(mailboxInfo: MailboxInfo): boolean {
    return !!getAccountScopeUserSettings(mailboxInfo).UserOptions?.IsFocusedInboxEnabled;
}
